module.exports = __webpack_public_path__ + "public/media/REAL..png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/lOGO PNG/REAL..png
// module id = ./images/partners/lOGO PNG/REAL..png
// module chunks = 0